import { render, staticRenderFns } from "./TabImport.vue?vue&type=template&id=54c599f6&scoped=true"
import script from "./TabImport.vue?vue&type=script&lang=js"
export * from "./TabImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c599f6",
  null
  
)

export default component.exports